import { defineNuxtPlugin } from "#app";
import { createI18n } from "vue-i18n";
import esMX from "@/locales/es-MX.json";
import "@/axios-config";
import VueLazyload from "vue-lazyload";
import loadimage from "@/assets/images/loading.gif";
import errorimage from "/images/imagen-no-disponible.png";
import Notifications from "@kyvg/vue3-notification";
import "~/fa-icons";

import analytics from "@/services/GoogleAnalyticsService";

const appDomain = import.meta.env.VITE_APP_DOMAIN;
if (appDomain && typeof location === "object" && location.host !== appDomain) {
  console.log(location.host, appDomain);
  location.href =
    location.protocol + "//" + appDomain + location.pathname + location.search;
}
// import initSentry from "./sentry-config.ts";

const VueLazyloadFixed =
  typeof VueLazyload.default === "object" ? VueLazyload.default : VueLazyload;

const i18n = createI18n<[typeof esMX], "es-MX">({
  legacy: false,
  locale: "es-MX",
  messages: {
    "es-MX": esMX,
  },
});

export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.env.SSR) {
    analytics.init();
  }
  const app = nuxtApp.vueApp;
  app
    .use(i18n)
    .use(VueLazyloadFixed, {
      preLoad: 0,
      error: errorimage,
      loading: loadimage,
      attempt: 1,
    })
    .use(Notifications);

  // if (!import.meta.env.SSR) {
  //   const win = window as unknown as { __pinia: Record<string, StateTree> };
  //   if (win.__pinia) {
  //     pinia.state.value = win.__pinia;
  //   }
  // }
});
